import React from 'react';
import styles from './TravelHospitality.module.css';
import backgroundImage from '../../Images/T2.png'; // Import from images folder
import icon12 from '../../Images/icon12.png';
import icon15 from '../../Images/icon15.png';
import icon16 from '../../Images/icon16.png';
import icon1 from '../../Images/icon1.png';
import icon2 from '../../Images/icon2.png';
import icon3 from '../../Images/icon3.png';
import icon4 from '../../Images/icon4.png';
import bT1 from '../../Images/bT1.png';
import bT2 from '../../Images/bT2.png';
import bT3 from '../../Images/bT3.png';

// import bg1 from '../../Images/bg1.png';
// import cd1 from '../../Images/cd1.png';
// import cd2 from '../../Images/cd2.png';
// import cd3 from '../../Images/cd3.png';
// import cd4 from '../../Images/cd4.png';
// import sicon1 from '../../Images/sicon1.png';


const TravelHospitality = () => {
  const handleCTAClick = (action) => {
    console.log(`${action} clicked`);
    // Add your navigation/modal logic here
  };

  return (
     <div className={styles.container}>
    {/* Hero Section */}
    <section className={styles.heroSection}>
      <div className={styles.heroContent}>
        {/* Top label */}
        <div className={styles.heroLabel}>
          <span className={styles.labelText}>AI-Powered Travel Solutions</span>
        </div>
        
        {/* Main headline */}
        <h1 className={styles.heroHeadline}>
          Revolutionize Travel & Hospitality with AI Automation
        </h1>
        
        {/* Subtext */}
        <p className={styles.heroSubtext}>
          Deliver seamless bookings, personalized guest experiences, and 24/7 support with intelligent AI agents
        </p>
        
        {/* CTA Buttons */}
        <div className={styles.ctaButtons}>
          <button 
            className={`${styles.ctaButton} ${styles.ctaPrimary}`}
            onClick={() => handleCTAClick('Request a Demo')}
          >
            Request a Demo →
          </button>
          <button 
            className={`${styles.ctaButton} ${styles.ctaSecondary}`}
            onClick={() => handleCTAClick('Learn More')}
          >
            Learn More
          </button>
        </div>
        
        {/* Stats Section */}
<div className={styles.statsSection}>
  <div className={styles.statItem}>
    <img src={icon12} alt="Speed Icon" className={styles.statIcon} />
    <div className={styles.statValue}>85%</div>
    <div className={styles.statLabel}>Booking Speed</div>
  </div>
  <div className={styles.statItem}>
    <img src={icon15} alt="Satisfaction Icon" className={styles.statIcon} />
    <div className={styles.statValue}>98%</div>
    <div className={styles.statLabel}>Guest Satisfaction</div>
  </div>
  <div className={styles.statItem}>
    <img src={icon16} alt="Support Icon" className={styles.statIcon} />
    <div className={styles.statValue}>24/7</div>
    <div className={styles.statLabel}>AI Support</div>
  </div>
</div>
      </div>
      
      {/* Background Image Container */}
      <div className={styles.heroBackground}>
        <div 
          className={styles.backgroundImage}
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
        />
      </div>
    </section>

      {/* Why AI-Powered Software Support
      <section className={styles.section}>
        <div className={styles.sectionContent}>
          <h2 className={styles.sectionTitle}>Why AI-Powered Software Support?</h2>
          <div className={styles.featuresGrid}>
            <div className={styles.featureCard}>
              <h3>24/7 Availability</h3>
              <p>Immediate assistance anytime for software issues.</p>
            </div>
            <div className={styles.featureCard}>
              <h3>Automated Fixes</h3>
              <p>AI detects errors and applies solutions instantly.</p>
            </div>
            <div className={styles.featureCard}>
              <h3>Reduce Downtime</h3>
              <p>Keep your software running smoothly.</p>
            </div>
            <div className={styles.featureCard}>
              <h3>Seamless Integration</h3>
              <p>Works with desktop, web, and mobile applications.</p>
            </div>
          </div>
        </div>
      </section> */}



      {/* Why AI-Powered Assessment Analysis */}
<section className={styles.aiSection}>
        <h2 className={styles.aiTitle}>Why Choose ToxboxAI for Travel?</h2>

        <div className={styles.aiGrid}>
          <div className={styles.aiCard}>
            <div className={styles.aiIcon}>
              <img src={icon1} alt="mini state" />
            </div>
            <h3>Automated Bookings</h3>
            <ul>
              <li>Process reservations 80% faster with AI-powered booking automation and instant confirmations.</li>
              <li>Prioritize the most promising prospects</li>
            </ul>
          </div>

          <div className={styles.aiCard}>
            <div className={styles.aiIcon}>
              <img src={icon2} alt="mini state" />
            </div>
            <h3>Smart Recommendations</h3>
            <ul>
              <li>Deliver personalized travel suggestions with instant AI analysis and predictive modeling.</li>
              <li>Optimize follow-ups based on AI recommendations</li>
            </ul>
          </div>

          <div className={styles.aiCard}>
            <div className={styles.aiIcon}>
              <img src={icon3} alt="mini state" />
            </div>
            <h3>24/7 Guest Support</h3>
            <ul>
              <li>Resolve queries instantly with 95% accuracy using advanced AI-powered virtual assistants.</li>
              <li>No more disconnected systems or missed leads</li>
            </ul>
          </div>

          <div className={styles.aiCard}>
            <div className={styles.aiIcon}>
              <img src={icon4} alt="mini state" />
            </div>
            <h3>Revenue Optimization</h3>
            <ul>
              <li>Increase revenue by up to 40% through intelligent upselling and dynamic pricing strategies.</li>
              <li>Let AI handle lead nurturing sequences</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Key Features */}
      {/* <section className={styles.section}>
        <div className={styles.sectionContent}>
          <h2 className={styles.sectionTitle}>Key Features</h2>
          <div className={styles.featuresList}>
            <div className={styles.featureItem}>
              <h4>Automated Troubleshooting</h4>
              <p>AI identifies bugs, crashes, and compatibility issues.</p>
            </div>
            <div className={styles.featureItem}>
              <h4>Patch & Update Management</h4>
              <p>Keep all applications updated automatically.</p>
            </div>
            <div className={styles.featureItem}>   
              <h4>Multi-Channel Support</h4>
              <p>Access via chat, email, or web portal.</p>
            </div>
            <div className={styles.featureItem}>
              <h4>Knowledge Base Integration</h4>
              <p>Instant guidance from software manuals and documentation.</p>
            </div>
            <div className={styles.featureItem}>
              <h4>Analytics & Insights</h4>
              <p>Monitor software performance and recurring issues.</p>
            </div>
          </div>
        </div>
      </section> */}


        {/* Seamless Bookings & Cancellations*/} 
<section className={styles.section11}>
  <div className={styles.container11}>
    <div className={styles.contentWrapper11}>
      {/* Left side - Text Content */}
      <div className={styles.textContent11}>
        <div className={styles.textHeader11}>
          <h2 className={styles.sectionTitle11}>Seamless Bookings & Cancellations</h2>
          <p className={styles.sectionSubtitle11}>
            Automate reservations across hotels, flights, and tours with instant confirmations and easy modifications
          </p>
        </div>
        
        <div className={styles.featuresList11}>
          <div className={styles.featureItem11}>
            <div className={styles.featureIconWrapper11}>
              {/* You can replace this with an actual icon component or SVG */}
              <div className={styles.iconCircle11}>
                <span className={styles.iconText11}>✓</span>
              </div>
            </div>
            <div className={styles.featureText11}>
              <h3 className={styles.featureTitle11}>Real-time booking updates</h3>
              <p className={styles.featureDescription11}>
                Get instant confirmations and live availability across all platforms
              </p>
            </div>
          </div>
          
          <div className={styles.featureItem11}>
            <div className={styles.featureIconWrapper11}>
              <div className={styles.iconCircle11}>
                <span className={styles.iconText11}>✓</span>
              </div>
            </div>
            <div className={styles.featureText11}>
              <h3 className={styles.featureTitle11}>Automated cancellations and refunds</h3>
              <p className={styles.featureDescription11}>
                Handle cancellations seamlessly with intelligent refund processing
              </p>
            </div>
          </div>
          
          <div className={styles.featureItem11}>
            <div className={styles.featureIconWrapper11}>
              <div className={styles.iconCircle11}>
                <span className={styles.iconText11}>✓</span>
              </div>
            </div>
            <div className={styles.featureText11}>
              <h3 className={styles.featureTitle11}>Multi-platform integration</h3>
              <p className={styles.featureDescription11}>
                Connect with all major booking platforms and travel systems
              </p>
            </div>
          </div>
        </div>
        
        <button className={styles.primaryButton11}>
          <span>Automate Bookings</span>
          <span className={styles.buttonArrow11}>→</span>
        </button>
      </div>
      
      {/* Right side - Image/Visual */}
      <div className={styles.imageContainer11}>
        <div className={styles.imageWrapper11}>
          {/* Main dashboard image */}
          <div className={styles.mainImageContainer11}>
            <img 
              src={bT1} 
              alt="Booking Dashboard Interface"
              className={styles.heroImage11}
            />
          </div>
          
          
          
          
          
          
        </div>
      </div>
    </div>
  </div>
</section>





      {/* Tailored Travel Recommendations */}
<section className={styles.section12}>
  <div className={styles.container12}>
    <div className={styles.contentWrapper12}>
      {/* Left side - Image/Visual */}
      <div className={styles.imageContainer12}>
        <div className={styles.imageWrapper12}>
          <div className={styles.mainImageContainer12}>
            <img 
              src={bT2} 
              alt="Travel Recommendations Dashboard"
              className={styles.heroImage12}
            />
          </div>
        </div>
      </div>
      
      {/* Right side - Text Content */}
      <div className={styles.textContent12}>
        <div className={styles.textHeader12}>
          <h2 className={styles.sectionTitle12}>Tailored Travel Recommendations</h2>
          <p className={styles.sectionSubtitle12}>
            AI-driven suggestions for destinations, packages, and experiences based on traveler preferences
          </p>
        </div>
        
        <div className={styles.featuresList12}>
          <div className={styles.featureItem12}>
            <div className={styles.featureIconWrapper12}>
              <div className={styles.iconCircle12}>
                <span className={styles.iconText12}>✓</span>
              </div>
            </div>
            <div className={styles.featureText12}>
              <h3 className={styles.featureTitle12}>Smart itinerary planning</h3>
              <p className={styles.featureDescription12}>
                Create optimized travel plans based on preferences and budget
              </p>
            </div>
          </div>
          
          <div className={styles.featureItem12}>
            <div className={styles.featureIconWrapper12}>
              <div className={styles.iconCircle12}>
                <span className={styles.iconText12}>✓</span>
              </div>
            </div>
            <div className={styles.featureText12}>
              <h3 className={styles.featureTitle12}>Personalized package recommendations</h3>
              <p className={styles.featureDescription12}>
                Match travelers with perfect vacation packages using AI insights
              </p>
            </div>
          </div>
          
          <div className={styles.featureItem12}>
            <div className={styles.featureIconWrapper12}>
              <div className={styles.iconCircle12}>
                <span className={styles.iconText12}>✓</span>
              </div>
            </div>
            <div className={styles.featureText12}>
              <h3 className={styles.featureTitle12}>Upsell & cross-sell opportunities</h3>
              <p className={styles.featureDescription12}>
                Increase revenue with intelligent upgrade and add-on suggestions
              </p>
            </div>
          </div>
        </div>
        
        <button className={styles.primaryButton12}>
          <span>Enhance Guest Experience</span>
          <span className={styles.buttonArrow12}>→</span>
        </button>
      </div>
    </div>
  </div>
</section>

      {/* Always-On Guest Assistance */}
<section className={styles.section13}>
  <div className={styles.container13}>
    <div className={styles.contentWrapper13}>
      {/* Left side - Text Content */}
      <div className={styles.textContent13}>
        <div className={styles.textHeader13}>
          <h2 className={styles.sectionTitle13}>Always-On Guest Assistance</h2>
          <p className={styles.sectionSubtitle13}>
            Resolve queries, complaints, and service requests instantly via AI-powered chat and voice agents
          </p>
        </div>
        
        <div className={styles.featuresList13}>
          <div className={styles.featureItem13}>
            <div className={styles.featureIconWrapper13}>
              <div className={styles.iconCircle13}>
                <span className={styles.iconText13}>✓</span>
              </div>
            </div>
            <div className={styles.featureText13}>
              <h3 className={styles.featureTitle13}>Instant responses across channels</h3>
              <p className={styles.featureDescription13}>
                Provide immediate support on web, mobile, SMS, and voice
              </p>
            </div>
          </div>
          
          <div className={styles.featureItem13}>
            <div className={styles.featureIconWrapper13}>
              <div className={styles.iconCircle13}>
                <span className={styles.iconText13}>✓</span>
              </div>
            </div>
            <div className={styles.featureText13}>
              <h3 className={styles.featureTitle13}>Multilingual support</h3>
              <p className={styles.featureDescription13}>
                Communicate with guests in 100+ languages automatically
              </p>
            </div>
          </div>
          
          <div className={styles.featureItem13}>
            <div className={styles.featureIconWrapper13}>
              <div className={styles.iconCircle13}>
                <span className={styles.iconText13}>✓</span>
              </div>
            </div>
            <div className={styles.featureText13}>
              <h3 className={styles.featureTitle13}>AI handling FAQs and complex queries</h3>
              <p className={styles.featureDescription13}>
                Resolve 90% of inquiries without human intervention
              </p>
            </div>
          </div>
        </div>
        
        <button className={styles.primaryButton13}>
          <span>Deploy AI Assistant</span>
          <span className={styles.buttonArrow13}>→</span>
        </button>
      </div>
      
      {/* Right side - Image/Visual */}
      <div className={styles.imageContainer13}>
        <div className={styles.imageWrapper13}>
          <div className={styles.mainImageContainer13}>
            <img 
              src={bT3} 
              alt="AI Assistant Chat Interface"
              className={styles.heroImage13}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>



      {/* Data-Driven Hospitality Decisions*/}
      <section className={styles.section14}>
  <div className={styles.sectionContent14}>
    <h2 className={styles.sectionTitle14}>Data-Driven Hospitality Decisions</h2>
    
    <div className={styles.introText14}>
      <p>Drive insights via intelligent analysis of booking trends, guest feedback, and market data to optimize operations</p>
    </div>
    
    <div className={styles.benefitsGrid14}>
      <div className={styles.benefitCard14}>
        <div className={styles.cardContent14}>
          <h4>Occupancy rate optimization</h4>
          <p>Analyze booking patterns to maximize room occupancy and revenue</p>
        </div>
      </div>
      
      <div className={styles.benefitCard14}>
        <div className={styles.cardContent14}>
          <h4>Guest sentiment analysis</h4>
          <p>Understand guest feedback and improve service quality</p>
        </div>
      </div>
      
      <div className={styles.benefitCard14}>
        <div className={styles.cardContent14}>
          <h4>Predictive demand forecasting</h4>
          <p>Anticipate future demand and optimize pricing strategies</p>
        </div>
      </div>
    </div>
  </div>
</section>

      {/* Call to Action */}
            <section className={styles.ctaSection}>
               <div className={styles.sectionContent}>
                <h2 className={styles.ctaHeadline}>Ready to Transform Your Travel Business?</h2>
                <p className={styles.ctaSubtext}>
                  Join leading hotels and travel brands using AI to deliver exceptional guest experiences.
                </p>
                <div className={styles.ctaButtons15}>
                  <button 
                    className={`${styles.ctaButton15} ${styles.ctaPrimary15}`}
                    onClick={() => handleCTAClick('Request a Demo')}
                  >
                    Schedule a Demo

                  </button>
                  <button 
                    className={`${styles.ctaButton15} ${styles.ctaSecondary15}`}
                    onClick={() => handleCTAClick('Get Started Now')}
                  >
                    View Case Studies
                  </button>
                </div>
              </div>
              
            </section>
    </div>
  );
};

export default TravelHospitality;
